import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card as CardMUI,
  CardActions as CardActionsMUI,
  CardContent,
  IconButton,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@vr/lib';
import styled from 'styled-components';
import { isMobile } from 'is-mobile';
import devices from '~/styles/devices';
import { Button, H2 } from '../../elements';
import {
  Container as DefaultContainerCommon,
  PageContainer as DefaultPageContainer,
} from '~/pages/common';
import { SVAS } from '~/pages/SVA';

type IconType = {
  code: number;
};

const Title = styled(H2)`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: -63px;

  .back-button {
    color: ${({ theme }) => theme.colors.white};
    margin-right: 10px;
    width: 48px;
    height: 48px;
    text-align: center;
  }

  @media (min-width: ${devices?.desktop}) {
    justify-content: center;
    .back-button {
      display: none;
    }
  }
`;
const DefaultContainer = styled(DefaultContainerCommon)`
  display: flex;
  flex-direction: column;
  margin-top: 72px;
`;
const PageContainer = styled(DefaultPageContainer)`
  flex-direction: column;
  background: white;
  width: 100%;
  margin-top: 73px;
`;
const Card = styled(CardMUI)`
  width: 100%;
  max-width: 888px;
  border-radius: 10px;
  padding: 6px;
  margin: 0 auto 29px;
`;
const Type = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;
const Name = styled.p`
  color: ${({ theme }) => theme.colors.institucional};
  font-weight: 600;
  font-size: 1rem;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.gray400};
  font-size: 0.938rem;
  margin-bottom: 15px;
`;
const Contact = styled(Description)`
  font-weight: 600;
  margin-bottom: 0;
`;
const Icon = styled(FontAwesomeIcon)<IconType>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray300};
  font-size: 2.4rem;
  height: 45px;
  margin-right: 6px;
  transform: ${({ code }) => (code === 608 ? 'rotate(-45deg)' : 'rotate(0)')};
`;
const CardActions = styled(CardActionsMUI)`
  padding: 0 0 15px 17px !important;

  .MuiButtonBase-root {
    background: ${({ theme }) => theme.colors.institucional};
    color: ${({ theme }) => theme.colors.white};
  }

  .MuiButtonBase-root:hover {
    background: ${({ theme }) => theme.colors.institucionalLight};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export default function Content({ svas }: { svas: Array<SVAS> }) {
  const history = useHistory();

  function handleLink(
    siteUrl: string,
    androidApp: string,
    iosApp: string,
  ): string {
    let url = siteUrl.includes('http') ? siteUrl : `https://${siteUrl}`;
    const mobileUrl = androidApp || iosApp;

    if (isMobile() && mobileUrl) {
      url = mobileUrl;
    }

    return url;
  }

  function getIcon(code: number): string {
    let icon = '';
    if (code === 680) {
      icon = 'utensils-alt';
    }
    if (code === 601) {
      icon = 'pills';
    }
    if (code === 604) {
      icon = 'user-hard-hat';
    }
    if (code === 604) {
      icon = 'user-hard-hat';
    }
    if (code === 608) {
      icon = 'dumbbell';
    }

    return icon;
  }

  return (
    <PageContainer>
      <Title color="white">
        <IconButton
          className="back-button"
          onClick={() => history.push('/home')}
        >
          <FontAwesomeIcon icon={['far', 'angle-left']} />
        </IconButton>
        <span>Serviços Adicionais</span>
      </Title>
      {/* @ts-ignore */}
      <DefaultContainer fullWidth>
        {svas.map((sva: SVAS) => {
          const {
            codigo,
            nomePortal,
            descricaoPortal,
            telefoneAtendimentoBeneficiario,
            siteAtendimentoBeneficiario,
            linkAppAndroid,
            linkAppIOS,
          } = sva;
          return (
            <Card key={codigo} data-testid="sva">
              <CardContent>
                <Type>
                  <Icon icon={['fal', getIcon(codigo)]} code={codigo} />
                  <Name>{nomePortal}</Name>
                </Type>
                <Description>{descricaoPortal}</Description>
                <Contact>Telefone: {telefoneAtendimentoBeneficiario}</Contact>
              </CardContent>
              <CardActions>
                <a
                  href={handleLink(
                    siteAtendimentoBeneficiario,
                    linkAppAndroid,
                    linkAppIOS,
                  )}
                  target="_blank"
                  rel="noreferrer"
                >
                  {/* @ts-ignore */}
                  <Button label="ACESSE AQUI" size="small" />
                </a>
              </CardActions>
            </Card>
          );
        })}
      </DefaultContainer>
    </PageContainer>
  );
}
